import React from 'react'
import { CURATORS_IMAGE } from '../helpers/constants'
import Button from './MainButton'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-type='block-wrapper'>
      <div data-type='block' data-style='share'>
        <div data-type='block-image'>
          <picture data-type='image'>
            <img
              width='502'
              height='501'
              itemProp='image'
              src={CURATORS_IMAGE}
              alt='hero'
              role='presentation'
              data-type='image'
            />
          </picture>
        </div>
        <div data-type='block-text' data-style='second-item'>
          <p data-type='block-title'>Share Your Art with a Global Audience in New Ways</p>
          <p data-type='block-sub-text'>
            Expand your audience across Saatchi Art’s channels while managing your portfolio and
            sales all from one place.
          </p>
          <p data-type='block-sub-text'>
            <span>Create your online profile in minutes:</span> Upload your artworks, complete your
            profile, and start sharing your portfolio with the Saatchi Art community and your
            network instantly.
          </p>
          <p data-type='block-sub-text'>
            <span>Commissions and offers:</span> Accept and negotiate offers from collectors, or
            work with our curators on original commissions for Art Advisory clients.
          </p>
          <p data-type='block-sub-text'>
            <span>Art Advisory:</span> Get handpicked by our curators for recommendation to a wide
            range of clients, from designers to architects to emerging and seasoned collectors.
          </p>
        </div>
      </div>
      <Button dataStyle='share-button' modalName='from-share' />
    </div>
  )
}

export default Component